<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-03 10:27:24
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button
          @click="toAddManuscript"
          v-if="codeData.indexOf('384') != -1"
          type="primary"
          >发起约稿</el-button
        >
      </div>
      <div class="right">
         <a-range-picker style="margin-right:12px" showTime v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
       <a-input-group compact>
                <a-select
                v-model="selectName"
                style="width: 120px; background: #ccc;margin-left:12px"
                >
                <a-select-option
                    @click="selectFn(item.value)"
                    :key="index"
                    v-for="(item, index) in selectArr"
                >
                    {{ item.label }}
                </a-select-option>
                </a-select>
                <a-input
                v-model="seachValue"
                placeholder="按关键字搜索"
                style="width: 173px;margin-right:12px"
                />
            </a-input-group>
        <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
     
    >
      <template v-slot:state="scopeVal">
          {{scopeVal.scope.state==1?'未报送':'已报送'}}
     </template>
      <template v-slot:user="scopeVal">
          {{scopeVal.scope.user?scopeVal.scope.user:'—'}}
     </template>
      <template v-slot:operation="scopeVal">
        <div style="display: flex">
          <div
            @click="submitted(scopeVal.scope,true)"
            class="btnTwo"
            style="margin-right: 14px;"
            v-if="scopeVal.scope.state ==1 && codeData.indexOf('389') != -1"
          >
            投稿
          </div>
           <div
            @click="submitted(scopeVal.scope,false)"
            class="btnTwo"
            style="margin-right: 14px;"
             v-if="scopeVal.scope.state ==2 && codeData.indexOf('388') != -1"
          >
            编辑
          </div>
        </div>
      </template>
    </coententTable>
     <initiateAppoint @closeDra="closeTwo"  @close="close" :visible="visible"></initiateAppoint>
       <AddSubmission :isAdd="isAdd" @close="closeAdd" :item="itemData" :type="1" @onClose="onClose" :visible="visibleAdd"></AddSubmission>
  </div>
</template>

<script>
import {
  selectMyListPage,
  
} from "./index";
import coententTable from "@/components/coentent_table.vue";
import AddSubmission from '../ManuscriptSubmitted/add_submission.vue'
import initiateAppoint from './Initiate_appointment.vue';
export default {
  data() {
    return {
      selectName: "约稿单位",
      valueName: "",
      visible:false,
      selectValue: 1,
      seachValue:'',
      isAdd:true,
      visibleAdd:false,
      selectArr:[
                {
                    'label':'约稿单位',
                    'value':1,
                },
                {
                    'label':'联系人',
                    'value':2,
                },
                {
                    'label':'报送人',
                    'value':3,
                }
            ],
      height: 0,
      time: [],
      value: [],
      isFabu: false,
      columns: [
        {
          title: "约稿标题",
          dataIndex: "title",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
      },
        {
          title: "约稿单位",
          dataIndex: "unit",
          width: 120,
          ellipsis: true,
        },
        {
          title: "约稿时间",
          dataIndex: "reservationTime",
          width: 120,
        },
         {
          title: "反馈时间",
          dataIndex: "feedbackTime",
          width: 200,
        },
         {
          title: "报送途径",
          dataIndex: "road",
          width: 200,
        },
         {
          title: "联系人",
          dataIndex: "contacts",
          width: 200,
        },
         {
          title: "状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
          width: 200,
        },
         {
          title: "报送人",
          dataIndex: "user",
          width: 200,
          scopedSlots: { customRender: "user" },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 120,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      columnId: "",
      customSlot: [
        {
          name: "state",
          customRender: "state",
        },
         {
          name: "user",
          customRender: "user",
        },
      ],
      rowKeys: [],
      seeData: {},
      states:[],
      loading: false,
      isSelectRow: true,
      loading: false,
      dialogVisibleTwo: false,
      dataSourceColunm: [],
      itemColumn: {},
      dialogVisibleColum: false,
      codeData: [],
      dialogVisible:false,
      itemData:{},
    };
  },
  components: {
    coententTable,
    initiateAppoint,
    AddSubmission
    
  },
  props: ["type"],
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    closeTwo(){
      this.visible = false;
    },
    submitted(item,type){
      this.visibleAdd = true;
      this.isAdd = type;
      this.itemData = item;
    },
    onClose(){
      this.visibleAdd = false;
       this.getList();
    },
    closeAdd(){
       this.visibleAdd = false;
    },
     close() {
      this.visible = false;
      this.getList()
    },
    toAddManuscript() {
       this.visible = true;
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      selectMyListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.seachValue,
        type: this.selectValue,
        startTime,
        endTime,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
        sessionStorage.removeItem("myManuscriptsPage");
        sessionStorage.removeItem("manuscriptsType");
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon-st-doc-edit:before {
      color: #fff;
      margin-right: 5px;
      font-size: 16px;
    }
    .batch-operation {
      margin-left: 10px;
      margin-right: 12px;
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.column-style {
  display: flex;
  cursor: pointer;
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
.title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  color: rgba(24, 109, 230, 1);
  }
  /deep/ .ant-input-group{
    width: auto;
  }
</style>